// Singleton WebSocket to the chat backend with auto-reconnect.
let ws = null;
let listeners = new Set();
let reconnectTimer = null;
let pingTimer = null;
let closedByUs = false;

function wsUrl() {
  const base = process.env.REACT_APP_BACKEND_URL || "";
  const token = localStorage.getItem("vault_token");
  return base.replace(/^http/, "ws") + `/api/ws?token=${encodeURIComponent(token)}`;
}

export function connectWS() {
  // Don't connect (or keep reconnecting) once the user is signed out.
  if (!localStorage.getItem("vault_token")) { disconnectWS(); return; }
  if (ws && (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CONNECTING)) return;
  closedByUs = false;
  try {
    ws = new WebSocket(wsUrl());
  } catch {
    return;
  }
  ws.onopen = () => {
    clearInterval(pingTimer);
    pingTimer = setInterval(() => {
      if (ws && ws.readyState === WebSocket.OPEN) ws.send(JSON.stringify({ type: "ping" }));
    }, 5000);
  };
  ws.onmessage = (e) => {
    let data;
    try { data = JSON.parse(e.data); } catch { return; }
    if (data.type === "pong") return;
    listeners.forEach((fn) => fn(data));
  };
  ws.onclose = () => {
    clearInterval(pingTimer);
    clearTimeout(reconnectTimer);
    // Only auto-reconnect if we didn't close on purpose and the user is still signed in.
    if (!closedByUs && localStorage.getItem("vault_token")) {
      reconnectTimer = setTimeout(connectWS, 3000);
    }
  };
  ws.onerror = () => { try { ws.close(); } catch {} };
}

export function sendWS(obj) {
  if (ws && ws.readyState === WebSocket.OPEN) ws.send(JSON.stringify(obj));
}

export function onWS(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function disconnectWS() {
  closedByUs = true;
  clearInterval(pingTimer);
  clearTimeout(reconnectTimer);
  if (ws) { try { ws.close(); } catch {} ws = null; }
}
